<template>
  <BaseIconButton
    v-tooltip="label"
    icon="bookmark"
    :color="color"
    :size="size"
    :shape="shape"
    :toggle="toggle"
    :selected="isBookmarked"
    :aria-label="label"
    :aria-pressed="isBookmarked ? 'true' : 'false'"
    @click.stop="toggleBookmark"
    @mousedown.stop
  />
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
  import type { ButtonShape } from '@/core/components/base/button/button-shape'
  import type { ButtonSize } from '@/core/components/base/button/button-size'
  import type { IconButtonProps } from '@/core/components/base/button/button-props'
  import { useBookmarkLessonImpulse } from '../composables/use-bookmark-lesson-impulse'

  interface Props {
    impulse: {
      id: string
      bookmarkedAt: string | null
    }
    color?: IconButtonProps['color']
    size?: ButtonSize
    shape?: ButtonShape
    toggle?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    color: 'standard',
    size: 'S',
    shape: 'round',
    toggle: false,
  })

  const { t } = useI18n()
  const { toggleBookmark } = useBookmarkLessonImpulse(() => props.impulse)
  const isBookmarked = computed(() => Boolean(props.impulse.bookmarkedAt))
  const label = computed(() =>
    isBookmarked.value ? t('lumia.bookmark.remove') : t('lumia.bookmark.add'),
  )
</script>
